// src/data/girls-fashion/age2to6.ts

import { Product } from "../../../interfaces/common/girls_fashion";

export const girlsFashionAge2to6: Product[] = [
  {
    id: 1,
    productId: 1,
    title: "A.T.U.N. (ALL THINGS UBER NICE) Girl's Cotton A-Line Above The Knee Dress",
    image: "/images/girls_fashion/fashioAge2to6/2to6_id_one.png",
    badge: "",
    url: "https://amzn.to/43skhUG",
  },
  {
    id: 2,
    productId: 2,
    title: "ANTHRILO Warm Cotton Rich Fleece Sweatshirt Jogger Set For Baby Girls",
    image: "/images/girls_fashion/fashioAge2to6/2to6_id_two.png",
    badge: "",
    url: "https://amzn.to/43JLjbn",
  },
  {
    id: 3,
    productId: 3,
    title: "NFashion Girl's Synthetic Fit and Flare Knee-Length Dress",
    image: "/images/girls_fashion/fashioAge2to6/2to6_id_three.png",
    badge: "Orange, Red and Pink",
    url: "https://amzn.to/4kagi6e",
  },
  {
    id: 4,
    productId: 4,
    title: "Pspeaches Girls COORDINATED_OUTFIT",
    image: "/images/girls_fashion/fashioAge2to6/2to6_id_four.png",
    badge: "White cotton",
    url: "https://amzn.to/4mCvevQ",
  },
  {
    id: 5,
    productId: 5,
    title: "Pspeaches Girl's Cotton Midi Dress",
    image: "/images/girls_fashion/fashioAge2to6/2to6_id_five.png",
    badge: "Blue cottone",
    url: "https://amzn.to/4kmiNlW",
  },
  {
    id: 6,
    productId: 6,
    title: "Fashion Dream Girl's Fit And Flare Midi Dress",
    image: "/images/girls_fashion/fashioAge2to6/2to6_id_six.png",
    badge: "Blue and Purple",
    url: "https://amzn.to/44VzIas",
  },
  {
    id: 7,
    productId: 7,
    title: "Clothe Funn Girls Allover Printed Frock Pink AOP",
    image: "/images/girls_fashion/fashioAge2to6/2to6_id_seven.png",
    badge: "Pink AOP cottone",
    url: "https://amzn.to/45rSpma",
  },
  {
    id: 8,
    productId: 8,
    title: "A.T.U.N. (ALL THINGS UBER NICE) Girl Dress",
    image: "/images/girls_fashion/fashioAge2to6/2to6_id_eight.png",
    badge: "Navy-Gold, Amethyst-Silver etc.",
    url: "https://amzn.to/43faEKi",
  },
];
